import { initializeApp } from 'firebase/app'
import { decrypt } from './utils'

function getMeasurementId(env: string) {
  if (env.includes('prod')) return process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PRODUCTION
  else if (env.includes('stage')) return process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_STAGING
  else return process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const measurementId = getMeasurementId(window.location.href)

const firebaseConfig = {
  apiKey: decrypt(
    process.env.REACT_APP_FIREBASE_API_ENCRYPTED_KEY || '',
    process.env.REACT_APP_FIREBASE_API_SECRET || ''
  ),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId
}
export default initializeApp(firebaseConfig)
